import React, { FunctionComponent, SVGProps } from 'react';
import { useTheme } from 'styled-components';

export interface DateIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
  isInvertedTheme?: boolean;
}

export const DateIcon: FunctionComponent<DateIconProps> = ({
  className,
  isInvertedTheme,
  ...props
}) => {
  const theme = useTheme();

  const getPathColor = () => {
    if (isInvertedTheme) {
      return theme.colors.background;
    }

    return theme.colors.primary;
  };

  return (
    <svg
      width={18}
      height={18}
      viewBox="0 0 18 18"
      className={className || ''}
      {...props}
    >
      <path
        fill={getPathColor()}
        fillRule="evenodd"
        d="M2.66,0C1.2,0,0,1.35,0,3.01V15.45c0,1.41,1.02,2.55,2.26,2.55H15.75c.6,0,1.17-.26,1.6-.74,.42-.48,.66-1.12,.66-1.81V3.03c.01-1.67-1.18-3.03-2.65-3.03H2.66ZM15.75,13.79c0,.98-.69,1.76-1.56,1.76H3.81c-.86,0-1.56-.79-1.56-1.76V7.59c0-.98,.69-1.76,1.56-1.76H14.2c.86,0,1.56,.79,1.56,1.76v6.2h-.01Z"
      />
    </svg>
  );
};

export default DateIcon;
